import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    honorificTitles: [],
    honorificTitle: {}
  },
  mutations: {
    index(state, payload) {
      state.honorificTitles = payload
    },
    show(state, payload) {
      state.honorificTitle = payload
    }
  },
  actions: {
    index({ commit }) {
      return axios.get(`${ENV.API_URL}/api/honorific_titles`).then((res) => {
        commit('index', res.data)
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/honorific_titles/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({ commit }, payload) {
      axios.post(`${ENV.API_URL}/api/honorific_titles`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    update({ commit }, payload) {
      axios.put(`${ENV.API_URL}/api/honorific_titles/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    honorificTitles: state => {
      return state.honorificTitles
    },
    honorificTitle: state => {
      return state.honorificTitle
    }
  },
  modules: {
  }
}
